export default "__VITE_ASSET__DrzIk1eV__"